import React from "react";
import styles from "./BrainCard.module.css";
import Metadata from "../questionList/components/metaData/Metadata";
import QuestionAnswerSection from "../questionList/components/questionAnswerSection/QuestionAnswerSection";
import CustomButton, {
  ButtonType,
} from "../../../../../components/button/CustomButton";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/common/store";
import { KnowledgeType } from "../../../../../util/KnowledgeType";
import { showConsoleError } from "../../../../../util/ConsoleMessage";
import { KnowledgeCard } from "../../../../../api/responsePayload/KnowledgeResponse";
import DocumentSection from "../questionList/components/documentSection/DocumentSection";
import { BrainBulkDelete } from "../../../../../api/KnowledgeApiCall";
import { fetchBrainList } from "../../../../../store/brain.slice";
import { useAppDispatch } from "../../../../../store/common/hooks";

interface BrainCard {
  data: KnowledgeCard;
}

const BrainCard: React.FC<BrainCard> = ({ data }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const localData = data;

  const { currentPage } = useSelector((state: RootState) => state.pagination);

  const handleReject = async () => {
    try {
      await BrainBulkDelete([data.knowledgeId]);
      dispatch(fetchBrainList({ page: currentPage }));
    } catch (e) {
      showConsoleError(e);
    }
  };

  return (
    <div className={styles["question-group-scroll-container"]}>
      <div className={styles["question-group-container"]}>
        <div className={styles["question-group-main"]}>
          <div className={styles["question-container"]}>
            <Metadata
              text={`Id: ${localData.id}  KnowledgeContentId: ${localData.knowledgeId} `}
            />
            {data.type == KnowledgeType.DOCUMENT && (
              <>
                <DocumentSection content={data.content ?? ""} color={"#fff"} />
              </>
            )}

            {data.type == KnowledgeType.FAQ && (
              <QuestionAnswerSection
                questionTitle={"Question"}
                answerTitle={"Answer"}
                question={localData.question}
                answer={localData.answer}
                color={"#fff"}
                classNameStyle={styles["remove-padding"]}
                openSelector={() => {}}
                knowledge_content_image={data.knowledge_content_image}
              />
            )}
            <div className={styles["buttons-container"]}>
              <CustomButton
                text={t("newManager.reject")}
                type={ButtonType.Reject}
                onClick={handleReject}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrainCard;
